import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SubTitle } from '../../components';

const StyledNews = styled.div`
border-bottom:${(props) => props.theme.lightGray} solid 1px;
padding:40px;
&:hover{
  background:${(props) => props.theme.lightWhite};
}
  &:last-child{
    border-bottom:0px;
  }
  h1{
    font-weight:normal;
  }
  h3{
    color: ${(props) => props.theme.primaryColor} ;
    font-size:12px;
    margin:0px;
    padding:0px;
  }
  p{
    font-size:14px;
    line-height:22px;
    margin:0px;
    padding:0px;
  }
`;

function News(props) {
  const { newsLink, newsDate, newsTitle, newsDec } = props;
  return (
    <StyledNews>
      <Link to={newsLink} target="_blank">
        <h3>{newsDate}</h3>
        <SubTitle fontSize="28px">{newsTitle}</SubTitle>
        <p>{newsDec}</p>
      </Link>
    </StyledNews>
  );
}

News.propTypes = {
  newsLink: propTypes.string,
  newsDate: propTypes.string,
  newsTitle: propTypes.string,
  newsDec: propTypes.string,
};

export default News;



// WEBPACK FOOTER //
// client/containers/Press/news.js